import { Button as AButton } from 'antd';
import 'antd/dist/reset.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {
// 	faPlus, faEdit, faTimes, faSave, faSearch, faPaw, faCircleXmark,
// 	faDownload,
// 	faCirclePlay, faCirclePause, faCircleDot, faCircleStop
// } from '@fortawesome/free-solid-svg-icons'
//堃
const Button = (props) => {
	let _cType = "default";
	let _bIsDanger = false;
	let _oIcon = null;
	const eType = props.eType ?? "";
	// switch (eType) {
	// 	case "新增": _cType = "primary"; _oIcon = faPlus; break;
	// 	case "編輯": _cType = "primary"; _oIcon = faEdit; break;
	// 	case "刪除": _cType = "primary"; _oIcon = faTimes; _bIsDanger = true; break;
	// 	case "儲存": _cType = "primary"; _oIcon = faSave; break;
	// 	case "查詢": _cType = "default"; _oIcon = faSearch; break;
	// 	case "確定": _cType = "primary"; _oIcon = faPaw; break;
	// 	case "取消": _cType = "default"; _oIcon = faCircleXmark; break;
	// 	case "下載": _cType = "default"; _oIcon = faDownload; break;
	// 	case "播放": _cType = "primary"; _oIcon = faCirclePlay; break;
	// 	case "暫停": _cType = "default"; _oIcon = faCirclePause; break;
	// 	case "錄音": _cType = "primary"; _oIcon = faCircleDot; break;
	// 	case "停止": _cType = "primary"; _oIcon = faCircleStop; _bIsDanger = true; break;
	// 	default: break;
	// }
	const cType = props.cType ?? _cType;
	const cHtmlType = props.cHtmlType ?? "button";
	const bIsDanger = props.bIsDanger ?? _bIsDanger;
	const oIcon = props.oIcon ?? _oIcon;
	const cText = (props.cText ?? eType);
	const bEnabled = (props.bEnabled ?? true);
	const bDisabled = (props.bDisabled ?? !bEnabled);
	const this_OnClick = () => {
		if (typeof props.onClick === "function") {
			const aData = Object.keys(props).reduce((aTemp, cKey) => {
				if (cKey.startsWith("data-")) { aTemp[cKey.substr(5)] = props[cKey]; }
				return aTemp;
			}, []);
			props.onClick(aData);
		} else {
			return true;
		}
	};

	return (
		<AButton name={props.name} type={cType} htmlType={cHtmlType} danger={bIsDanger} onClick={this_OnClick} style={props.style} className={props.className} disabled={bDisabled}>
			{/* {props.bHideIcon !== true &&
				<FontAwesomeIcon icon={oIcon} style={{ ...props.iconStyle, marginRight: "5px" }}></FontAwesomeIcon>
			} */}
			{cText}
		</AButton>
	);
}
export default Button;